import React, { useCallback, useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CalendarAppointment from './Calendar';
import DateSelector from './DateSelector';
import setBookedAppointment from '../../api/ClientBookAppointment/setBookedAppointment.api';
import styles from './BookAppointment.module.scss';
import ClientForm from './ClientForm';
import { Grid } from '@material-ui/core';
import ThankYou from './ThankYou';
import getSalesAgentDetails from '../../api/ClientBookAppointment/getSalesAgentDetails.api';
import CustomButton from '../layout/customButton/CustomButton';
import { setAlert } from '../../redux/alerts/action';

const BookAppointment = (props) => {
	const { setAlert } = props;
	const [loading, setLoading] = useState(false);
	const [appointmentDate, setAppointmentDate] = useState(new Date());
	const [agentSelected, setAgentSelected] = useState();
	const [agentIdSelected, setAgentIdSelected] = useState();
	const [bookedTimeList, setBookedTimeList] = useState([]);
	const [clickedTime, setClickedTime] = useState(false);
	const [selectTime, setSelectTime] = useState();
	const [salesAgentsChosen, setSalesAgentsChosen] = useState();
	const [formData, setFormData] = useState({
		email: '',
		fullName: '',
		phoneNumber: '',
	});
	const [openDetailsForm, setOpenDetailsForm] = useState(false);
	const [confirmedTime, setConfirmedTime] = useState();
	// const [disabled, setDisabled] = useState();
	const [finishAppointment, setFinishAppointment] = useState(false);
	const [salesAgentDetails, setSalesAgentDetails] = useState();

	const handleConfirm = useCallback(async (e) => {
		console.log(salesAgentsChosen);
		if (salesAgentsChosen) {
			setBookedAppointment(
				salesAgentsChosen,
				formData.email,
				formData.fullName,
				formData.phoneNumber,
				confirmedTime,
				(type, message) => {
					setAlert(type, message);
				},
				setFinishAppointment,
				setOpenDetailsForm
				// setDisabled
			);

			salesAgentsChosen &&
				(await getSalesAgentDetails(salesAgentsChosen, (returned) => {
					setSalesAgentDetails(returned);
					console.log('getSalesAgentDetails returned', returned);
				}));
			setClickedTime(false);
		} else {
			setAlert(
				'warning',
				'No sales agents are available at this time slot.'
			);

			// setDisabled(false);
		}
		setOpenDetailsForm(false);
	});

	return (
		<>
			{finishAppointment === false && (
				<div className={styles.book_appointment_page}>
					<h2 className={styles.title}>Book Appointment</h2>
					<center>
						<Grid className={styles.gridWrapper} container>
							<Grid
								className={styles.gridItem}
								item
								xs={12}
								sm={9}
							>
								<CalendarAppointment
									appointmentDate={appointmentDate}
									setAppointmentDate={setAppointmentDate}
									agentSelected={agentSelected}
									agentIdSelected={agentIdSelected}
									setBookedTimeList={setBookedTimeList}
								/>
							</Grid>
							<Grid
								className={styles.gridItem}
								item
								xs={12}
								sm={3}
							>
								<DateSelector
									appointmentDate={appointmentDate}
									setAgentIdSelected={setAgentIdSelected}
									bookedTimeList={bookedTimeList}
									setSelectTime={setSelectTime}
									selectTime={selectTime}
									handleConfirm={handleConfirm}
									setClickedTime={setClickedTime}
									clickedTime={clickedTime}
									setSalesAgentsChosen={setSalesAgentsChosen}
									setOpenDetailsForm={setOpenDetailsForm}
									setConfirmedTime={setConfirmedTime}
									// setDisabled={setDisabled}
								/>
							</Grid>
						</Grid>
					</center>
					<ClientForm
						openDetailsForm={openDetailsForm}
						handleConfirm={handleConfirm}
						formData={formData}
						setFormData={setFormData}
						setOpenDetailsForm={setOpenDetailsForm}
						// setDisabled={setDisabled}
					/>
				</div>
			)}

			{finishAppointment === true && (
				<ThankYou
					salesAgentName={salesAgentDetails?.name}
					appointmentTime={confirmedTime}
				/>
			)}
		</>
	);
};

export default connect(null, {
	setAlert,
})(BookAppointment);
